module.exports = __webpack_public_path__ + "img/Storage-Room.529b6cec.png";